import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import filter from 'lodash/filter';
import { useTranslation } from 'react-i18next';
import Autosuggest from 'react-autosuggest';
import './style.scss';
import { Avatar } from 'antd';
import { useDispatch } from 'react-redux';
import { SEARCH } from 'api';
import useFetch from 'utils/fetch/useFetch';
import { fetchSuccess } from '../../store/reducers/fetchSlice';
import { ReactComponent as SearchIcon } from '../../images/search.svg';
import { ReactComponent as User } from '../../images/user_searh.svg';
import { ReactComponent as StoreIcon } from '../../images/search_icon_sclad.svg';

function Filter({ updateData, dataSource, uniqId, placeholder, manager }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { data, getData } = useFetch(SEARCH, {
    uniqId: 'search',
    autoFetch: false,
  });

  const [value, setValue] = useState('');
  const [suggestions, setSuggestions] = useState([]);

  const getSuggestions = (value, data) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    return inputLength === 0
      ? []
      : data.filter((item) => {
          if (item.type === 'box' || item.type === 'section') {
            return (
              item.data.name.toLowerCase().slice(0, inputLength) === inputValue
            );
          } else if (item.type === 'user') {
            return (
              item.data.last_name.toLowerCase().slice(0, inputLength) ===
                inputValue ||
              item.data.first_name.toLowerCase().slice(0, inputLength) ===
                inputValue
            );
          } else if (item.type === 'warehouse') {
            return (
              item.data.name.toLowerCase().slice(0, inputLength) === inputValue
            );
          }
        });
  };

  useEffect(() => {
    if (data) {
      setSuggestions(getSuggestions(value, data));
    }
  }, [data]);

  const filterSource = (data) => {
    if (uniqId === 'users') {
      if (data.type === 'box') {
        if (data.data.transaction) {
          const newData = filter(dataSource, (item) => {
            return item.id === data.data.transaction.client.id;
          });
          dispatch(
            fetchSuccess({
              uniqId: uniqId,
              response: { data: newData },
            }),
          );
        }
      } else if (data.type === 'user') {
        const newData = filter(dataSource, (item) => {
          return item.id === data.data.id;
        });
        dispatch(
          fetchSuccess({
            uniqId: uniqId,
            response: { data: newData },
          }),
        );
      }
    } else if (uniqId === 'transactions') {
      if (data.type === 'box') {
        const newData = filter(dataSource, (item) => {
          return item.box.id === data.data.id;
        });
        dispatch(
          fetchSuccess({
            uniqId: uniqId,
            response: { data: newData },
          }),
        );
      } else if (data.type === 'user') {
        const newData = filter(dataSource, (item) => {
          return item.client_id === data.data.id;
        });
        dispatch(
          fetchSuccess({
            uniqId: uniqId,
            response: { data: newData },
          }),
        );
      }
    } else if (uniqId === 'boxes') {
      if (data.type === 'box') {
        const newData = filter(dataSource, (item) => {
          return item.id === data.data.id;
        });
        dispatch(
          fetchSuccess({
            uniqId: uniqId,
            response: { data: newData },
          }),
        );
      }
      // else if (data.type === 'user') {
      //   const newData = filter(dataSource, (item) => {
      //     return item.client_id === data.data.id;
      //   });
      //   dispatch(
      //     fetchSuccess({
      //       uniqId: uniqId,
      //       response: { data: newData },
      //     }),
      //   );
      // }
    }
  };

  const getSuggestionValue = (suggestion) => {
    filterSource(suggestion);
    if (suggestion.type === 'user') {
      return `${suggestion.data.first_name} ${suggestion.data.last_name}`;
    } else {
      return suggestion.data.name;
    }
  };

  const renderSuggestion = (suggestion) => {
    if (suggestion.type === 'user') {
      return (
        <div className="flex pl-13 type-user">
          {manager ? (
            <Avatar>{suggestion.data.first_name[0]}</Avatar>
          ) : (
            <User className="mr-12" />
          )}
          <span className="text-graytext mr-5">{t('user')} </span>
          <span className="text-black border-b-1 border-dotted">
            {suggestion.data.first_name}
            {` `}
            {suggestion.data.last_name}
          </span>
        </div>
      );
    } else if (suggestion.type === 'box') {
      return (
        <div className="flex pl-13 type-store">
          <StoreIcon className="mr-12" />
          <span className="text-graytext mr-5">{t('box')} </span>
          <span className="text-black border-b-1 border-dotted">
            {suggestion.data.name}
          </span>
        </div>
      );
    } else if (suggestion.type === 'section') {
      return (
        <div className="flex pl-13 type-store">
          <StoreIcon className="mr-12" />
          <span className="text-graytext mr-5">{t('section')} </span>
          <span className="text-black border-b-1 border-dotted">
            {suggestion.data.name}
          </span>
        </div>
      );
    } else if (suggestion.type === 'warehouse') {
      return (
        <div className="flex pl-13 type-store">
          <StoreIcon className="mr-12" />
          <span className="text-graytext mr-5">{t('storage')} </span>
          <span className="text-black border-b-1 border-dotted">
            {suggestion.data.name}
          </span>
        </div>
      );
    }
  };

  const onChange = (event, { newValue }) => {
    // if (newValue === '') {
    //   updateData();
    // }
    setValue(newValue);
  };

  const onSuggestionsFetchRequested = ({ value }) => {
    if (value !== '') {
      getData({
        q: value,
      });
    }
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const inputProps = {
    placeholder,
    value,
    onChange,
  };

  return (
    <div className="relative flex-grow">
      <SearchIcon className="absolute z-50 bottom-15 left-15" />
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
      />
    </div>
  );
}

Filter.propTypes = {};

export default Filter;
